import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useApi from "_api/index";
import FormDocumentList from "components/Car/FormDocumentList";
import { Description, Edit, Print } from "@mui/icons-material";
import Actions from "components/Car/Actions";
import ModalContractConsignmentCar from "components/Modal/Car/FormDocuments/ContractConsignmentCar";
import { Box, IconButton } from "@mui/material";
import { BackButton } from "components/Button";

const FormConsignmentCars = () => {
  const { id } = useParams();
  const [loading, setLoading] = React.useState(false);
  const [carDetail, setCarDetail] = React.useState(null);
  const [isOpenModal, setIsOpenModal] = React.useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await useApi.consignment_car.getConsignmentCarById(id);
      if (response.success) {
        setCarDetail(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handlePrintPDF = async (document_id) => {
    try {
      const response = await useApi.consignment_car.printPdfConsignmetContact(
        carDetail.car.car_id
      );
      if (response && response.status === 200) {
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "contract_consignment_car.pdf");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      } else {
        console.error("Failed to generate PDF");
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  return (
    <>
      <FormDocumentList
        car={carDetail && carDetail.car}
        type="consignment_car"
        loading={loading}
        columns={[
          { key: "document", label: "ฟอร์มเอกสาร" },
          {
            key: "action",
            label: "",
            style: {
              textAlign: "right",
            },
            render: (row) => {
              const findCreated = carDetail
                ? carDetail.documents.find(
                    (doc) => doc.document_type === row.document_type
                  )
                : null;

              return (
                <Actions
                  menuList={[
                    {
                      label: findCreated ? "แก้ไขเอกสาร" : "สร้างเอกสาร",
                      icon: findCreated ? <Edit /> : <Description />,
                      onClick: () => {
                        // Handle download action
                        // handleUpdateStsatus(row.document);
                        setIsOpenModal(true);
                      },
                    },
                    findCreated && {
                      label: "พิมพ์เอกสาร",
                      icon: <Print />,
                      onClick: () => {
                        handlePrintPDF(findCreated.document_id);
                      },
                    },
                  ]}
                />
              );
            },
          },
        ]}
        data={[
          {
            id: 1,
            document: "สัญญารับฝากขาย",
            document_type: "car_consignment_contact",
          },
        ]}
      />
      <Box sx={{ mt: 2 }}>
        <BackButton onClick={() => window.history.back()} />
      </Box>
      <ModalContractConsignmentCar
        open={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        rowID={id}
        car={carDetail && carDetail.car}
        consignment={carDetail && carDetail.consignment_detail}
        order={carDetail && carDetail.order}
        document={
          carDetail &&
          carDetail.documents.find(
            (doc) => doc.document_type === "car_consignment_contact"
          )
        }
        onSuccess={(msg) => {
          fetchData();
          setIsOpenModal(false);
        }}
      />
    </>
  );
};

export default FormConsignmentCars;
